import router from '@/router/index.js'
import axios from '../../axios'
export default {
  namespaced: true,
  state: {
    company: [],
    image: null
  },
  mutations: {
    SET_COMPANY(state, company) {
      state.company = company
    },
    ADD_IMAGE(state, item) {
      state.image = item
    },
  },
  actions: {
    fetchDataListItems({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('eld/company/')
          .then((response) => {
            commit('SET_COMPANY', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    addItem({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.post(`eld/company/`,
          (item)
        )
          .then((response) => {
            commit('SET_COMPANY', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchImgListItems({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('eld/company/image/')
          .then((response) => {
            commit('ADD_IMAGE', response.data.image)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    addImg({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.post(`eld/company/image/`,
          (item)
        )
          .then((response) => {
            commit('ADD_IMAGE', response.data.image)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    }
  },
  getters: {}
}